module.exports = [{
      plugin: require('/usr/local/nginx/html/other_domains/strangeworksinc/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/usr/local/nginx/html/other_domains/strangeworksinc/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
